import script from "./OutreachDraftDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OutreachDraftDetail.vue?vue&type=script&setup=true&lang=js"

import "./OutreachDraftDetail.vue?vue&type=style&index=0&id=16c8b474&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c8b474"]])

export default __exports__